import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "form-row mb-2 w-50" }
const _hoisted_4 = { class: "form-row-bottom" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "form-label-wrapper form-label-width" }, null, -1)
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Сохранить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_pre = _resolveComponent("base-pre")!
  const _component_FormPage = _resolveComponent("FormPage")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_pre, {
        hide: "",
        title: "edit entryData",
        data: _ctx.entryData
      }, null, 8, ["data"]),
      (_ctx.entryData && !_ctx.isEmptyObject(_ctx.entryData))
        ? (_openBlock(), _createBlock(_component_FormPage, {
            key: 0,
            ref: "formRefParent",
            data: _ctx.entryData,
            "onUpdate:data": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entryData) = $event)),
            edit: true,
            onSaveFormEmit: _ctx.saveForm
          }, null, 8, ["data", "onSaveFormEmit"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.buttonsLoading,
              onClick: _ctx.saveButtonClick
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ])
      ])
    ])
  ]))
}